export default "{\n    \"optionLabel\": \"Is Overdue\",\n    \"filterLabel\": \"Overdue\"\n}\n"